declare namespace $ {

	export class $easyreels_labeler_name extends $mol_labeler {
		value( ): string
		title( ): string
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=name.view.tree.d.ts.map